

































































































































































import { defineComponent, ref } from '@vue/composition-api'
import LineSplitter from '@/components/animation/LineSplitter.vue'
import Strech from '@/components/animation/Strech.vue'
import ArrowLink from '@/components/ArrowLink.vue'
import { motionOK } from '@/inc/utils/motionOK'
import gsap from 'gsap'

export default defineComponent({
  name: 'key-points',
  props: {
    content: {
      required: true,
      type: Object,
    },
  },
  components: {
    LineSplitter,
    ArrowLink,
    Strech,
  },
  setup() {
    const titleRef = ref()
    const headlineRef = ref()
    const contentRef = ref()
    const keypointsRef = ref()
    const keypointsValuesRef = ref()
    const keypointsLabelsRef = ref()
    const ctaRef = ref()

    const animateIn = () => {
      if (motionOK()) {
        const TL = gsap.timeline({
          defaults: {
            duration: 1,
            ease: 'power4.out',
          },
        })

        if (titleRef.value) {
          TL.add(titleRef.value.getTween(), 'start')
        }

        if (headlineRef.value) {
          TL.add(headlineRef.value.getTween(), 'start+=0.25')
        }

        if (contentRef.value) {
          TL.add(contentRef.value.getTween(), 'start+=0.5')
        }

        keypointsRef.value.forEach((keypoint, i) => {
          const nestedTL = gsap.timeline({
            defaults: {
              duration: 1,
              ease: 'power4.out',
            },
          })

          if (i % 2 === 0) {
            nestedTL.to(
              keypoint,
              {
                '--progress': 1,
              },
              'start'
            )
          }

          if (keypointsValuesRef.value[i]) {
            nestedTL.add(keypointsValuesRef.value[i].getTween(), 'start')
          }

          if (keypointsLabelsRef.value[i]) {
            nestedTL.add(keypointsLabelsRef.value[i].getTween(), 'start+=0.25')
          }

          TL.add(nestedTL, i === 0 ? '-=1.5' : '-=1')
        })

        if (ctaRef.value) {
          TL.add(ctaRef.value.getTween(), '-=0.5')
        }
      }
    }

    return {
      titleRef,
      headlineRef,
      contentRef,
      keypointsRef,
      keypointsValuesRef,
      keypointsLabelsRef,
      ctaRef,
      animateIn,
    }
  },
})
